import AnimatedCharacter from "../../AnimatedCharacter";
import common from "../../common";

export default class Boss extends AnimatedCharacter {
    constructor(name, type) {
        super(name);

        this._type = type;
        this._vos = P3.utils.copyObjectFast(P3.assets.json("bosses").filter(x => x.type === type)[0].audio.vo);
    }

    playTauntVO() {
        const sounds = this._vos.taunt.location[common.location.id].length ?
            Math.random() < 0.5 ? this._vos.taunt.location[common.location.id] : this._vos.taunt.generic : this._vos.taunt.generic;

        return P3.audio.playVO(sounds, 1, true);
    }

    playAttackVO() {
        return P3.audio.playVO(this._vos.attack, 1, true);
    }

    playDamageVO() {
        return P3.audio.playVO(this._vos.damage, 1, true);
    }

    playDamageSound() {
        return P3.audio.playSound([
            "sfx_generic_adversary_damage_00",
            "sfx_generic_adversary_damage_01",
            "sfx_generic_adversary_damage_02"
        ]);
    }

    get type() {
        return this._type;
    }
}

Boss.TYPE_DRAGON = "dragon";
Boss.TYPE_GOLDEN_DRAGON = "goldendragon";
Boss.TYPE_SPIDER = "spider";
Boss.TYPE_HOBGOBLIN = "hobgoblin";
Boss.TYPE_TROLL = "troll";
Boss.TYPE_TRAINING_TROLL = "trainingtroll";
Boss.TYPE_SPIRIT = "spirit";
Boss.TYPE_MAGE = "mage";